import type { HotelFeatures } from '../../types';

export const sliceFeatures = (
  features: HotelFeatures,
  maxVsibleValue: number,
): HotelFeatures => {
  const existsFeatures = Object.entries(features).filter(
    // ts ругается на _
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ([_, value]) => value,
  );

  if (existsFeatures.length > maxVsibleValue)
    existsFeatures.splice(maxVsibleValue);

  const defaultFetures = {
    airportDistance: null,
    beachDistance: null,
    beachSurface: null,
    beachLine: null,
    wiFi: null,
    distanceToCityCenter: 0,
  };

  const allFeatures = {
    ...defaultFetures,
    ...Object.fromEntries(existsFeatures),
  };
  return allFeatures;
};
